import keyMirror from 'keymirror';

export default keyMirror({
    FETCH_CONFIG: null,
    FETCH_CONFIG_SUCCESS: null,
    FETCH_CONFIG_ERROR: null
});
